import { useSelector } from 'react-redux'
import { SentimentCell } from '../../../../common/news/SentimentCell'
import { selectRowItem, selectSentiments } from '../../store/slice'

export const StatusCell = ({ val, rowId }) => {
  const data = useSelector(selectRowItem(rowId))
  const sentiments = useSelector(selectSentiments)

  return (
    <SentimentCell
      sentimentName={val}
      newsTypeIds={data?.newsTypeIds}
      defaultSentiments={sentiments}
    />
  )
}
